import {useEffect, useRef} from 'react';
import {usePostHog} from 'posthog-js/react';
import {useSummary} from 'context/summary';
import {getFeatureFlags} from '@chekin/core';

function PostHogPageViewTracker() {
  const posthog = usePostHog();
  const {data: summary, summaryStatus} = useSummary();
  const hasTrackedPageViewRef = useRef(false);
  const isTrackingEnabled = getFeatureFlags('POSTHOG_TRACKING');
  const isSummaryReady = summaryStatus !== 'loading' && summaryStatus !== 'pending';
  const upsellingActive = Boolean(summary?.upselling?.active);

  useEffect(() => {
    if (!isTrackingEnabled || !isSummaryReady) {
      return;
    }

    if (hasTrackedPageViewRef.current) {
      return;
    }

    posthog.capture('page_view', {
      upselling_active: upsellingActive,
    });
    hasTrackedPageViewRef.current = true;
  }, [posthog, isTrackingEnabled, isSummaryReady, upsellingActive]);

  return null;
}

export {PostHogPageViewTracker};
